<template>
  <div class="content" style="min-width: 1200px">
    <header class="header header--border" v-if="$route.name !== 'empty'">
      <div class="header_center">
        <div class="header_title" @click="goHome()">
          <h1 class="icon_container">
            <div class="icon" v-if="info.logo">
              <img :src="info.logo" alt="" />
            </div>
            <span>{{ info.oname }}</span>
          </h1>
          <div class="header_code">注册码：{{ info.ocode }}</div>
        </div>
        <component
          :is="isComponent"
          :userData="userData"
          v-if="$route.name != 'login'"
        ></component>
      </div>
    </header>
    <main class="main">
      <div class="main_center">
        <!-- <s-breadcrumb :breadList="breadList"></s-breadcrumb> -->
        <keep-alive include="CouresPage">
          <router-view></router-view>
        </keep-alive>
      </div>
    </main>
    <template
      v-if="
        $route.name !== 'login' &&
        $route.name !== 'wechatLogin' &&
        $route.name !== 'register' &&
        $route.name !== 'forgotPwd' &&
        $route.name !== 'empty'
      "
    >
      <Footer
        :name="info.oname"
        :logo="info.logo"
        v-if="$route.name != 'homeWork'"
      ></Footer>
    </template>
    <template v-else-if="$route.name === 'wechatLogin'"></template>
    <template v-else-if="$route.name === 'empty'"></template>
    <template v-else>
      <!-- <div
        style="
          font-size: 12px;
          font-weight: 400;
          color: #646568;
          text-align: center;
          margin-top: 100px;
        "
      >
        Copyright©2013-2023
        {{
          isOther ? '云浮市永盛教育科技有限公司' : '福建铸远教育科技有限公司'
        }}版权所有<br />{{
          isOther ? '粤ICP备2023112846号-2' : '闽ICP备14031391号-1'
        }}
      </div> -->
    </template>
  </div>
</template>
<script>
import Footer from './components/Footer'
import User from './components/User'
import { mapState } from 'vuex'
import Breadcrumb from '@/components/tools/Breadcrumb'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import Vue from 'vue'
export default {
  name: 'BaseLayout',
  components: {
    Footer,
    User,
    's-breadcrumb': Breadcrumb,
  },
  data() {
    return {
      is: User,
      isOther: false,
    }
  },
  computed: {
    ...mapState({
      info: (state) => state.system.orgInfo,
    }),
    userData() {
      return this.$store.getters.getUserData(['nickName', 'headImgUrl'])
    },
    isComponent() {
      const token = this.$store.state.user.token || this.$ls.get(ACCESS_TOKEN)
      return token ? User : null
    },
  },
  created() {
    // const location = window.location.href
    // const substr = 'yongsheng'
    // if (location.includes(substr)) {
    //   this.isOther = true
    // }
    const code = Vue.ls.get('code')
    if (code === 'yfys') {
      this.isOther = true
    }
  },
  methods: {
    goHome() {
      if (this.$route.name !== 'login') {
        this.$router.push({
          name: 'course',
          query: { ocode: Vue.ls.get('code') },
        })
      }
    },
  },
}
</script>
<style lang="less" scoped>
.content {
  height: 100%;
  display: flex;
  flex-direction: column;
  color: #fff;
  .header {
    height: 80px;
    min-height: 80px;
    background-color: #fff;
    .header_center {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .header_title {
      display: flex;
      align-items: center;
      .icon_container {
        height: 65px;
        user-select: none;
        cursor: pointer;
        margin-right: 16px;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        .icon {
          margin-right: 16px;
          display: inline-block;
          img {
            height: 48px;
            object-fit: contain;
          }
          // &::after {
          //   content: '';
          //   position: absolute;
          //   width: 1px;
          //   right: -18px;
          //   top: 18px;
          //   bottom: 18px;
          //   background: #c8d1ee;
          // }
        }
        span {
          font-size: 16px;
          font-weight: 600;
          color: #303133;
        }
      }
      .header_code {
        padding: 7px 18px;
        background: #e7eefd;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 600;
        color: #263238;
      }
      h3 {
        margin-right: 50px;
        line-height: 32px;
        font-size: 17px;
        font-weight: 600;
      }
    }
    .ant-dropdown-link {
      display: inline-block;
      height: 45px;
      line-height: 45px;
    }
  }
  .header--border {
    // border-bottom: 1px solid #ced3dc;
  }
  .main {
    flex: 1;
    .main_center {
      height: 100%;
      min-height: 658px;
      background: #f5f8fa;
    }
  }
}
</style>
